export const USER_FACEPAY_DOCS = "USER_FACEPAY_DOCS"

export const secretKey = "weedigital-sycomore"